module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-kia.50477298.jpg";